import React from "react";
import { Button } from "./Button";
import { RiArrowLeftSLine, RiArrowRightSLine } from "@remixicon/react";

interface LayoutProps {
  title: string;
  description?: string;
  stepTitle?: string;
  children: React.ReactNode;
  onButtonBackClick?: () => void;
  onButtonNextClick?: () => void;
  showBackButton?: boolean;
  showNextButton?: boolean;
  backButtonIcon?: React.ReactNode;
  nextButtonIcon?: React.ReactNode;
  nextButtonLabel?: string;
  enableNextButton?: boolean;
  stepIndicator?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({
  title,
  description,
  stepTitle,
  children,
  onButtonBackClick,
  onButtonNextClick,
  showBackButton = true,
  showNextButton = true,
  backButtonIcon = <RiArrowLeftSLine />,
  nextButtonIcon = <RiArrowRightSLine />,
  nextButtonLabel = "Volgende",
  enableNextButton = true,
  stepIndicator,
}) => {
  return (
    <div>
      <h1 className="text-xl font-semibold">{title}</h1>
      {description && (
        <h2 className="mt-1 text-sm text-gray-500">{description}</h2>
      )}
      <div className="mt-6">
        <section className="rounded-2xl bg-white px-6 py-6 shadow-sm ring-1 ring-inset ring-gray-200">
          {(stepTitle || stepIndicator) && (
            <div className="mb-4 flex items-center justify-between">
              {stepTitle && (
                <h2 className="text-base font-bold leading-7 text-gray-800">
                  {stepTitle}
                </h2>
              )}
              {stepIndicator}
            </div>
          )}
          <div className="space-y-4">{children}</div>
          {(showBackButton || showNextButton) && (
            <div className="mt-12 flex items-center justify-between">
              <div>
                {showBackButton && (
                  <Button onClick={onButtonBackClick} plain>
                    {backButtonIcon} Terug
                  </Button>
                )}
              </div>
              <div>
                {showNextButton && (
                  <Button
                    onClick={onButtonNextClick}
                    color="primary"
                    disabled={!enableNextButton}
                  >
                    {nextButtonLabel} {nextButtonIcon}
                  </Button>
                )}
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Layout;
